<template>
  <div class="loader-gift-root">
    <div class="loader-img" :style="`width: ${size}px; height: ${size}px; ${styles}`" v-show='loading'>
      <img src="https://gift-s365.foxconn.com/imgs/loading.gif">
      <p>加載中</p>
    </div>
    <div :class="{ 'data-loading': text }" v-show="!loading">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoaderCycle',
  props: {
    loading: {
      type: Boolean,
      default: true,
      required: false
    },
    size: {
      type: String | Number,
      default: 100,
      required: false
    },
    styles: {
      type: String,
      default: "",
      required: false
    },
    text: {
      type: String,
      default: "",
      required: false
    },
  }
}
</script>

<style lang="less" scoped>
.loader-gift-root{
  .loader-img{
    margin: 100px auto 0px;
    img{
      width: 100%;
    }
  }
  p{
    /* UI Properties */
    font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-normal) var(--unnamed-font-size-12)/var(--unnamed-line-spacing-18) var(--unnamed-font-family-noto-sans);
    letter-spacing: var(--unnamed-character-spacing-0);
    color: var(--text-main);
    text-align: center;
  }
  .data-loading{
    margin-top: 24px;
    position: relative;
    /* UI Properties */
    font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-normal) var(--unnamed-font-size-12)/var(--unnamed-line-spacing-18) var(--unnamed-font-family-noto-sans);
    letter-spacing: var(--unnamed-character-spacing-0);
    color: var(--text-inactive);
    text-align: center;
    a{
      color: #EF7555;
    }
    &:before{
      content: '';
      position: absolute;
      left: 0;
      width: 35%;
      height: 1px;
      top: 50%;
      /* UI Properties */
      background: #D7D8DE 0% 0% no-repeat padding-box;
    }
    &:after{
      content: '';
      position: absolute;
      right: 0;
      width: 35%;
      height: 1px;
      top: 50%;
      /* UI Properties */
      background: #D7D8DE 0% 0% no-repeat padding-box;
      opacity: 1;
    }
  }
}
</style>